var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.payments.length > 0
    ? _c("b-table", {
        staticClass: "table-responsive-xl resolution_table",
        attrs: {
          "thead-class": _vm.head_class,
          "tbody-tr-class": _vm.rowClass,
          striped: "",
          items: _vm.payments,
          fields: _vm.fields,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "head(date)",
              fn: function (data) {
                return [_vm._v("\n        Дата\n    ")]
              },
            },
            {
              key: "head(rest_count)",
              fn: function (data) {
                return [
                  _vm._v(
                    "\n        " + _vm._s(_vm.__t("SLOTS_COUNT")) + "\n    "
                  ),
                ]
              },
            },
            {
              key: "head(cost)",
              fn: function (data) {
                return [
                  _vm._v("\n        " + _vm._s(_vm.__t("COST")) + "\n    "),
                ]
              },
            },
            {
              key: "cell(cost)",
              fn: function (data) {
                return [
                  _c("div", [
                    _c("div", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("toCurrency")(parseInt(data.item.cost))
                          ) +
                          "\n\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("sup", [
                      data.item.status == "regular" || data.item.status == "pay"
                        ? _c(
                            "span",
                            { staticClass: "badge badge-success ml-2" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.__t("PAY")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              },
            },
          ],
          null,
          false,
          4182499563
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }